/**
  * 系统日志模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const logApi = {
    GetLogList: `${base.qa}/Log/GetLogList`,
}

const log = {
    GetLogList (params) {
        return axios.get(logApi.GetLogList, { params: { pageindex: params.pageindex, pagesize: params.pagesize, startdate: params.startdate, enddate: params.enddate } })
    },

}


export default log;